export enum AddressesOrderStatus {
    init = 'initialized',
    payed = 'payed',
    waitingForHOConfirmation = 'waitingForHOConfirmation',
    ordered = 'ordered'
}